import React from "react";
import { matchPath } from "react-router-dom";
import type { GeneratedPageDataConfig } from "./dataSource";

export interface GeneratedPageProps {
  data?: any;
}

export interface GeneratedPageRoute {
  pageId: string;
  routePath: string;
  Component: React.LazyExoticComponent<React.ComponentType<GeneratedPageProps>>;
  data?: GeneratedPageDataConfig;
}

export const generatedPageRegistry: GeneratedPageRoute[] = [
  {
    pageId: "generated-demo",
    routePath: "/demo",
    Component: React.lazy(() => import("./demo")),
    data: {
      defaultSource: "mock",
      mockLoader: async () => {
        const module = await import("./demo/mock");
        return module.default;
      },
    },
  },
  {
    pageId: "generated-demo",
    routePath: "/generated/demo",
    Component: React.lazy(() => import("./demo")),
    data: {
      defaultSource: "mock",
      mockLoader: async () => {
        const module = await import("./demo/mock");
        return module.default;
      },
    },
  },
  {
    pageId: "card-grid",
    routePath: "/",
    Component: React.lazy(() => import("./card-grid")),
    data: {
      defaultSource: "remote",
      dataKeys: ["card-grid"],
      // 保留 mockLoader，支持 ?mock=1 切回 mock 数据调试
      mockLoader: async () => {
        const module = await import("./card-grid/mock");
        return module.default;
      },
    },
  },
];

export const normalizeRoutePath = (routePath: string) => {
  if (!routePath || routePath === "/") {
    return "/";
  }

  const normalized = routePath.replace(/\/+/g, "/").replace(/\/$/, "");

  return normalized.startsWith("/") ? normalized : `/${normalized}`;
};

export const resolveGeneratedPage = (pathname: string) => {
  const normalizedPath = normalizeRoutePath(pathname);

  return generatedPageRegistry.find(route =>
    Boolean(matchPath({ path: normalizeRoutePath(route.routePath), end: true }, normalizedPath)),
  );
};
